module.exports = __webpack_public_path__ + "static/img/productHot2.bf09d116.png";